var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"bg-light app-height",attrs:{"fluid":""}},[_c('router-view',{attrs:{"managers":_vm.managers,"routes":_vm.routes,"route":_vm.route},on:{"changeRoute":_vm.changeRoute}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }